module.exports = __webpack_public_path__ + "img/EXTERIOR-SWIFT-SPORT-1.79d5ed90.jpg";